// frontend/src/components/GoogleLoginButton/GoogleLoginButton.jsx
// Só deve ser renderizado quando REACT_APP_GOOGLE_CLIENT_ID estiver definido.

import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { Button, Typography } from 'antd';
import { ehNavegadorInternoMetaAndroid } from '../../utils/navegadorInterno';

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18">
    <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z" />
    <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z" />
    <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z" />
    <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z" />
  </svg>
);

export function GoogleLoginButton({
  onSuccess,
  onError,
  loading = false,
  disabled = false,
  block = false,
  size = 'large',
  // 'login' troca "cadastre-se com e-mail" por "entre com e-mail" no aviso abaixo.
  contexto = 'cadastro',
}) {
  const googleLogin = useGoogleLogin({
    onSuccess,
    onError,
    flow: 'implicit',
  });

  // No navegador interno do Facebook/Instagram (Android) o Google pode recusar o
  // login; o botão continua visível, só com uma alternativa logo abaixo.
  const avisoNavegadorInterno = ehNavegadorInternoMetaAndroid();

  return (
    <>
      <Button
        block={block}
        size={size}
        onClick={() => googleLogin()}
        loading={loading}
        disabled={disabled}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
      >
        <GoogleIcon />
        Continuar com Google
      </Button>
      {avisoNavegadorInterno && (
        <Typography.Text
          type="secondary"
          style={{ display: 'block', textAlign: 'center', fontSize: 12, marginTop: 6 }}
        >
          Se o Google não abrir, {contexto === 'login' ? 'entre' : 'cadastre-se'} com e-mail ou toque em ⋯ e abra no navegador
        </Typography.Text>
      )}
    </>
  );
}

export const hasGoogleOAuth = Boolean(process.env.REACT_APP_GOOGLE_CLIENT_ID);
